module.exports = __webpack_public_path__ + "img/metro.9c9726a4.svg";